import React, { useState, useEffect } from "react";
import "../App.css";
import HeroSection from "../components/HeroSection";
import LazyLoad from "react-lazy-load";
import GridMediaLayout from "../components/GridMediaLayout";
import Gap from "../components/Gap";
import CenterMedia from "../components/CenterMedia";
import FullWidthMedia from "../components/FullWidthMedia";
// import CrossfadeGridMediaLayout from '../components/CrossfadeGridMediaLayout';
import CrossfadeImageColumns from "../components/CrossfadeImageColumns";
// import ImageCarousel from "../components/ImageCarousel";
// import FullWidthCarousel from "../components/FullWidthCarousel";
import ResponsiveImageCarousel from "../components/ResponsiveImageCarousel";
import Footer from "../components/Footer";
import ThreeColumns from "../components/ThreeColumns";

function Aesthetics() {
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  useEffect(() => {
    const handleUserInteraction = () => {
      setHasUserInteracted(true);
    };

    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);
    document.addEventListener("scroll", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
      document.removeEventListener("scroll", handleUserInteraction);
    };
  }, []);

  const mediaItems = [
    {
      type: "image",
      src: "../Aesthetics/Amit-agarwal/amg1.webp",
      alt: "Image AMG1",
      row: 1,
      column: 1,
    },
    {
      type: "image",
      src: "../Aesthetics/Amit-agarwal/amg4.webp",
      alt: "Image AMG4",
      row: 1,
      column: 2,
    },
    {
      type: "image",
      src: "../Aesthetics/Amit-agarwal/amg2.webp",
      alt: "Image AMG2",
      row: 2,
      column: 1,
    },
    {
      type: "image",
      src: "../Aesthetics/Amit-agarwal/amg3.webp",
      alt: "Image AMG3",
      row: 2,
      column: 2,
    },
  ];

  const crossfadeGridMediaImages = [
    [
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6579.webp",
        alt: "Fullwidth Image 6579",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6590.webp",
        alt: "Fullwidth Image 6590",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6592.webp",
        alt: "Fullwidth Image 6592",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6584.webp",
        alt: "Fullwidth Image 6584",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6594.webp",
        alt: "Fullwidth Image 6594",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6596.webp",
        alt: "Fullwidth Image 6596",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6600.webp",
        alt: "Fullwidth Image 6600",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6606.webp",
        alt: "Fullwidth Image 6606",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6608.webp",
        alt: "Fullwidth Image 6608",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6610.webp",
        alt: "Fullwidth Image 6610",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6612.webp",
        alt: "Fullwidth Image 6612",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6621.webp",
        alt: "Fullwidth Image 6621",
      },
    ],
    [
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6576.webp",
        alt: "Fullwidth Image 6576",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6578.webp",
        alt: "Fullwidth Image 6578",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6585.webp",
        alt: "Fullwidth Image 6585",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6593.webp",
        alt: "Fullwidth Image 6593",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6597.webp",
        alt: "Fullwidth Image 6597",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6599.webp",
        alt: "Fullwidth Image 6599",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6601.webp",
        alt: "Fullwidth Image 6601",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6605.webp",
        alt: "Fullwidth Image 6605",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6616.webp",
        alt: "Fullwidth Image 6616",
      },
      {
        src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6619.webp",
        alt: "Fullwidth Image 6619",
      },
    ],
  ];

  // const ruya_carousel_images = [
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6579.webp",
  //     alt: "Fullwidth Image 6579",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6590.webp",
  //     alt: "Fullwidth Image 6590",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6592.webp",
  //     alt: "Fullwidth Image 6592",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6584.webp",
  //     alt: "Fullwidth Image 6584",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6594.webp",
  //     alt: "Fullwidth Image 6594",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6596.webp",
  //     alt: "Fullwidth Image 6596",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6600.webp",
  //     alt: "Fullwidth Image 6600",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6606.webp",
  //     alt: "Fullwidth Image 6606",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6608.webp",
  //     alt: "Fullwidth Image 6608",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6610.webp",
  //     alt: "Fullwidth Image 6610",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6612.webp",
  //     alt: "Fullwidth Image 6612",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6621.webp",
  //     alt: "Fullwidth Image 6621",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6576.webp",
  //     alt: "Fullwidth Image 6576",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6578.webp",
  //     alt: "Fullwidth Image 6578",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6585.webp",
  //     alt: "Fullwidth Image 6585",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6593.webp",
  //     alt: "Fullwidth Image 6593",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6597.webp",
  //     alt: "Fullwidth Image 6597",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6599.webp",
  //     alt: "Fullwidth Image 6599",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6601.webp",
  //     alt: "Fullwidth Image 6601",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6605.webp",
  //     alt: "Fullwidth Image 6605",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6616.webp",
  //     alt: "Fullwidth Image 6616",
  //   },
  //   {
  //     src: "../Aesthetics/A&r-by-rhea/ruya/IMG_6619.webp",
  //     alt: "Fullwidth Image 6619",
  //   },
  // ];

  const rumani_carousel_images = [
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6637.webp",
      alt: "Rumani Image 6637",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6638.webp",
      alt: "Rumani Image 6638",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6639.webp",
      alt: "Rumani Image 6639",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6640.webp",
      alt: "Rumani Image 6640",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6624.webp",
      alt: "Rumani Image 6624",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6626.webp",
      alt: "Rumani Image 6626",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6627.webp",
      alt: "Rumani Image 6627",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6628.webp",
      alt: "Rumani Image 6628",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6630.webp",
      alt: "Rumani Image 6630",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6631.webp",
      alt: "Rumani Image 6631",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6632.webp",
      alt: "Rumani Image 6632",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6633.webp",
      alt: "Rumani Image 6633",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6634.webp",
      alt: "Rumani Image 6634",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6635.webp",
      alt: "Rumani Image 6635",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6636.webp",
      alt: "Rumani Image 6636",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6637.webp",
      alt: "Rumani Image 6637",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6638.webp",
      alt: "Rumani Image 6638",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6639.webp",
      alt: "Rumani Image 6639",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6640.webp",
      alt: "Rumani Image 6640",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6624.webp",
      alt: "Rumani Image 6624",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6626.webp",
      alt: "Rumani Image 6626",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6627.webp",
      alt: "Rumani Image 6627",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6628.webp",
      alt: "Rumani Image 6628",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6630.webp",
      alt: "Rumani Image 6630",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6631.webp",
      alt: "Rumani Image 6631",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6632.webp",
      alt: "Rumani Image 6632",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6633.webp",
      alt: "Rumani Image 6633",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6634.webp",
      alt: "Rumani Image 6634",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6635.webp",
      alt: "Rumani Image 6635",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6636.webp",
      alt: "Rumani Image 6636",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6637.webp",
      alt: "Rumani Image 6637",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6638.webp",
      alt: "Rumani Image 6638",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6639.webp",
      alt: "Rumani Image 6639",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6640.webp",
      alt: "Rumani Image 6640",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6624.webp",
      alt: "Rumani Image 6624",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6626.webp",
      alt: "Rumani Image 6626",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6627.webp",
      alt: "Rumani Image 6627",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6628.webp",
      alt: "Rumani Image 6628",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6630.webp",
      alt: "Rumani Image 6630",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6631.webp",
      alt: "Rumani Image 6631",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6632.webp",
      alt: "Rumani Image 6632",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6633.webp",
      alt: "Rumani Image 6633",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6634.webp",
      alt: "Rumani Image 6634",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6635.webp",
      alt: "Rumani Image 6635",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6636.webp",
      alt: "Rumani Image 6636",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6637.webp",
      alt: "Rumani Image 6637",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6638.webp",
      alt: "Rumani Image 6638",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6639.webp",
      alt: "Rumani Image 6639",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6640.webp",
      alt: "Rumani Image 6640",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6624.webp",
      alt: "Rumani Image 6624",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6626.webp",
      alt: "Rumani Image 6626",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6627.webp",
      alt: "Rumani Image 6627",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6628.webp",
      alt: "Rumani Image 6628",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6630.webp",
      alt: "Rumani Image 6630",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6631.webp",
      alt: "Rumani Image 6631",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6632.webp",
      alt: "Rumani Image 6632",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6633.webp",
      alt: "Rumani Image 6633",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6634.webp",
      alt: "Rumani Image 6634",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6635.webp",
      alt: "Rumani Image 6635",
    },
    {
      src: "../Aesthetics/A&r-by-rhea/rumani/IMG_6636.webp",
      alt: "Rumani Image 6636",
    },
  ];

  // const crossfadeGridMediaImages2 = [
  //   [
  //     { src: "../Aesthetics/sky/1a.webp", alt: "Sky Image 1a" },
  //     { src: "../Aesthetics/sky/1b.webp", alt: "Sky Image 1b" },
  //     { src: "../Aesthetics/sky/1c.webp", alt: "Sky Image 1c" },
  //   ],
  // ];

  // const spitiCarouselImages = [
  //   { src: "../Aesthetics/spiti/1.webp", alt: "Spiti Image 1" },
  //   { src: "../Aesthetics/spiti/2.webp", alt: "Spiti Image 2" },
  //   { src: "../Aesthetics/spiti/3.webp", alt: "Spiti Image 3" },
  //   { src: "../Aesthetics/spiti/4.webp", alt: "Spiti Image 4" },
  //   { src: "../Aesthetics/spiti/5.webp", alt: "Spiti Image 5" },
  //   { src: "../Aesthetics/spiti/6.webp", alt: "Spiti Image 6" },
  //   { src: "../Aesthetics/spiti/7.webp", alt: "Spiti Image 7" },
  //   { src: "../Aesthetics/spiti/8.webp", alt: "Spiti Image 8" },
  //   { src: "../Aesthetics/spiti/9.webp", alt: "Spiti Image 9" },
  //   { src: "../Aesthetics/spiti/10.webp", alt: "Spiti Image 10" },
  //   { src: "../Aesthetics/spiti/11.webp", alt: "Spiti Image 11" },
  //   { src: "../Aesthetics/spiti/12.webp", alt: "Spiti Image 12" },
  //   { src: "../Aesthetics/spiti/13.webp", alt: "Spiti Image 13" },
  //   { src: "../Aesthetics/spiti/16.webp", alt: "Spiti Image 16" },
  // ];

  const jerseyImages = [
    [{ src: "../Aesthetics/jersey/DSCF8405.webp", alt: "Jersey Image 1" }],
    [{ src: "../Aesthetics/jersey/DSCF8411.webp", alt: "Jersey Image 2" }],
    [{ src: "../Aesthetics/jersey/DSCF8416.webp", alt: "Jersey Image 3" }],
  ];

  // const boultImages2Col = [
  //   [{ src: "../Aesthetics/boult/DSCF3495.webp", alt: "Boult Image 1" }],
  //   [{ src: "../Aesthetics/boult/DSCF3563.webp", alt: "Boult Image 2" }],
  // ];

  // const boultImages1Col = [
  //   [{ src: "../Aesthetics/boult/DSCF3540.webp", alt: "Boult Image 1" }],
  // ];

  const kenwoodImages3Col = [
    [{ src: "../Aesthetics/kenwood/DSCF8626.webp", alt: "Kenwood Image 1" }],
    [{ src: "../Aesthetics/kenwood/DSCF8624.webp", alt: "Kenwood Image 2" }],
    [{ src: "../Aesthetics/kenwood/DSCF8703.webp", alt: "Kenwood Image 3" }],
  ];

  // const mehakImages = [
  //   [{ src: "../Aesthetics/mehak/image00001.webp", alt: "Mehak Image 1" }],
  //   [{ src: "../Aesthetics/mehak/image00004.webp", alt: "Mehak Image 2" }],
  //   [{ src: "../Aesthetics/mehak/image00015.webp", alt: "Mehak Image 3" }],
  // ];

  const mehakCarouselImages = [
    {
      src: "../Aesthetics/mehak/image00001.webp",
      alt: "Mehak Image 00001",
    },
    {
      src: "../Aesthetics/mehak/image00004.webp",
      alt: "Mehak Image 00004",
    },
    {
      src: "../Aesthetics/mehak/image00006.webp",
      alt: "Mehak Image 00006",
    },
    {
      src: "../Aesthetics/mehak/image00008.webp",
      alt: "Mehak Image 00008",
    },
    {
      src: "../Aesthetics/mehak/image00009.webp",
      alt: "Mehak Image 00009",
    },
    {
      src: "../Aesthetics/mehak/image00015.webp",
      alt: "Mehak Image 00015",
    },
    {
      src: "../Aesthetics/mehak/image00001.webp",
      alt: "Mehak Image 00001",
    },
    {
      src: "../Aesthetics/mehak/image00004.webp",
      alt: "Mehak Image 00004",
    },
    {
      src: "../Aesthetics/mehak/image00006.webp",
      alt: "Mehak Image 00006",
    },
    {
      src: "../Aesthetics/mehak/image00008.webp",
      alt: "Mehak Image 00008",
    },
    {
      src: "../Aesthetics/mehak/image00009.webp",
      alt: "Mehak Image 00009",
    },
    {
      src: "../Aesthetics/mehak/image00015.webp",
      alt: "Mehak Image 00015",
    },
    {
      src: "../Aesthetics/mehak/image00001.webp",
      alt: "Mehak Image 00001",
    },
    {
      src: "../Aesthetics/mehak/image00004.webp",
      alt: "Mehak Image 00004",
    },
    {
      src: "../Aesthetics/mehak/image00006.webp",
      alt: "Mehak Image 00006",
    },
    {
      src: "../Aesthetics/mehak/image00008.webp",
      alt: "Mehak Image 00008",
    },
    {
      src: "../Aesthetics/mehak/image00009.webp",
      alt: "Mehak Image 00009",
    },
    {
      src: "../Aesthetics/mehak/image00015.webp",
      alt: "Mehak Image 00015",
    },
    {
      src: "../Aesthetics/mehak/image00001.webp",
      alt: "Mehak Image 00001",
    },
    {
      src: "../Aesthetics/mehak/image00004.webp",
      alt: "Mehak Image 00004",
    },
    {
      src: "../Aesthetics/mehak/image00006.webp",
      alt: "Mehak Image 00006",
    },
    {
      src: "../Aesthetics/mehak/image00008.webp",
      alt: "Mehak Image 00008",
    },
    {
      src: "../Aesthetics/mehak/image00009.webp",
      alt: "Mehak Image 00009",
    },
    {
      src: "../Aesthetics/mehak/image00015.webp",
      alt: "Mehak Image 00015",
    },
    {
      src: "../Aesthetics/mehak/image00001.webp",
      alt: "Mehak Image 00001",
    },
    {
      src: "../Aesthetics/mehak/image00004.webp",
      alt: "Mehak Image 00004",
    },
    {
      src: "../Aesthetics/mehak/image00006.webp",
      alt: "Mehak Image 00006",
    },
    {
      src: "../Aesthetics/mehak/image00008.webp",
      alt: "Mehak Image 00008",
    },
    {
      src: "../Aesthetics/mehak/image00009.webp",
      alt: "Mehak Image 00009",
    },
    {
      src: "../Aesthetics/mehak/image00015.webp",
      alt: "Mehak Image 00015",
    },
  ];

  const kashmir_textiles_images = [
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3256.webp",
      alt: "Kashmir Textiles Image 3256",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3460.webp",
      alt: "Kashmir Textiles Image 3460",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3463.webp",
      alt: "Kashmir Textiles Image 3463",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3618.webp",
      alt: "Kashmir Textiles Image 3618",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3672.webp",
      alt: "Kashmir Textiles Image 3672",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3752.webp",
      alt: "Kashmir Textiles Image 3752",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4090.webp",
      alt: "Kashmir Textiles Image 4090",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4126.webp",
      alt: "Kashmir Textiles Image 4126",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4177.webp",
      alt: "Kashmir Textiles Image 4177",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4196.webp",
      alt: "Kashmir Textiles Image 4196",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4210.webp",
      alt: "Kashmir Textiles Image 4210",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3256.webp",
      alt: "Kashmir Textiles Image 3256",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3460.webp",
      alt: "Kashmir Textiles Image 3460",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3463.webp",
      alt: "Kashmir Textiles Image 3463",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3618.webp",
      alt: "Kashmir Textiles Image 3618",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3672.webp",
      alt: "Kashmir Textiles Image 3672",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3752.webp",
      alt: "Kashmir Textiles Image 3752",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4090.webp",
      alt: "Kashmir Textiles Image 4090",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4126.webp",
      alt: "Kashmir Textiles Image 4126",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4177.webp",
      alt: "Kashmir Textiles Image 4177",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4196.webp",
      alt: "Kashmir Textiles Image 4196",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4210.webp",
      alt: "Kashmir Textiles Image 4210",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3256.webp",
      alt: "Kashmir Textiles Image 3256",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3460.webp",
      alt: "Kashmir Textiles Image 3460",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3463.webp",
      alt: "Kashmir Textiles Image 3463",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3618.webp",
      alt: "Kashmir Textiles Image 3618",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3672.webp",
      alt: "Kashmir Textiles Image 3672",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3752.webp",
      alt: "Kashmir Textiles Image 3752",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4090.webp",
      alt: "Kashmir Textiles Image 4090",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4126.webp",
      alt: "Kashmir Textiles Image 4126",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4177.webp",
      alt: "Kashmir Textiles Image 4177",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4196.webp",
      alt: "Kashmir Textiles Image 4196",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4210.webp",
      alt: "Kashmir Textiles Image 4210",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3256.webp",
      alt: "Kashmir Textiles Image 3256",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3460.webp",
      alt: "Kashmir Textiles Image 3460",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3463.webp",
      alt: "Kashmir Textiles Image 3463",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3618.webp",
      alt: "Kashmir Textiles Image 3618",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3672.webp",
      alt: "Kashmir Textiles Image 3672",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF3752.webp",
      alt: "Kashmir Textiles Image 3752",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4090.webp",
      alt: "Kashmir Textiles Image 4090",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4126.webp",
      alt: "Kashmir Textiles Image 4126",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4177.webp",
      alt: "Kashmir Textiles Image 4177",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4196.webp",
      alt: "Kashmir Textiles Image 4196",
    },
    {
      src: "../Aesthetics/kashmir-textiles/DSCF4210.webp",
      alt: "Kashmir Textiles Image 4210",
    },
  ];

  // const vogueVidhishaImages = [
  //   {
  //     type: "image",
  //     src: "../Aesthetics/vogue-vidhisha/DSCF1432-02.webp",
  //     alt: "Vogue Vidhisha Image DSCF1432-02",
  //     row: 1,
  //     column: 1,
  //   },
  //   {
  //     type: "image",
  //     src: "../Aesthetics/vogue-vidhisha/DSCF1432-01.webp",
  //     alt: "Vogue Vidhisha Image DSCF1432-01",
  //     row: 1,
  //     column: 2,
  //   },
  //   {
  //     type: "image",
  //     src: "../Aesthetics/vogue-vidhisha/DSCF1432-03.webp",
  //     alt: "Vogue Vidhisha Image DSCF1432-03",
  //     row: 1,
  //     column: 3,
  //   },
  //   {
  //     type: "image",
  //     src: "../Aesthetics/vogue-vidhisha/DSCF1432-04.webp",
  //     alt: "Vogue Vidhisha Image DSCF1432-04",
  //     row: 2,
  //     column: 1,
  //   },
  //   {
  //     type: "image",
  //     src: "../Aesthetics/vogue-vidhisha/Jacket-Dust-Cover-Book-Presentation-Mockup.webp",
  //     alt: "Vogue Vidhisha Jacket Dust Cover",
  //     row: 2,
  //     column: 2,
  //   },
  //   {
  //     type: "image",
  //     src: "../Aesthetics/vogue-vidhisha/DSCF1432-05.webp",
  //     alt: "Vogue Vidhisha Image DSCF1432-05",
  //     row: 2,
  //     column: 3,
  //   },
  // ];

  const vogueVidhishaImagesRow1 = [
    [
      {
        type: "image",
        src: "../Aesthetics/vogue-vidhisha/DSCF1432-02.webp",
        alt: "Vogue Vidhisha Image DSCF1432-02",
      },
    ],
    [
      {
        type: "image",
        src: "../Aesthetics/vogue-vidhisha/DSCF1432-01.webp",
        alt: "Vogue Vidhisha Image DSCF1432-01",
      },
    ],
    [
      {
        type: "image",
        src: "../Aesthetics/vogue-vidhisha/DSCF1432-03.webp",
        alt: "Vogue Vidhisha Image DSCF1432-03",
      },
    ],
  ];

  // const vogueVidhishaImagesRow2 = [
  //   [
  //     {
  //       type: "image",
  //       src: "../Aesthetics/vogue-vidhisha/DSCF1432-04.webp",
  //       alt: "Vogue Vidhisha Image DSCF1432-04",
  //     },
  //   ],
  //   [
  //     {
  //       type: "image",
  //       src: "../Aesthetics/vogue-vidhisha/Jacket-Dust-Cover-Book-Presentation-Mockup.webp",
  //       alt: "Vogue Vidhisha Jacket Dust Cover",
  //     },
  //   ],
  //   [
  //     {
  //       type: "image",
  //       src: "../Aesthetics/vogue-vidhisha/DSCF1432-05.webp",
  //       alt: "Vogue Vidhisha Image DSCF1432-05",
  //     },
  //   ],
  // ];

  // const mulmulImages = [
  //   {
  //     type: "image",
  //     src: "../Aesthetics/mulmul/DSCF4443.webp",
  //     alt: "Mul Mul Image DSCF4443",
  //     row: 1,
  //     column: 1,
  //   },
  //   {
  //     type: "image",
  //     src: "../Aesthetics/mulmul/DSCF4509.webp",
  //     alt: "Mul Mul Image DSCF4509",
  //     row: 1,
  //     column: 2,
  //   },
  //   {
  //     type: "image",
  //     src: "../Aesthetics/mulmul/DSCF4446.webp",
  //     alt: "Mul Mul Image DSCF4446",
  //     row: 1,
  //     column: 3,
  //   },
  // ];

  const mulmulImages2 = [
    [
      {
        src: "../Aesthetics/mulmul/DSCF4443.webp",
        alt: "Mul Mul Image DSCF4443",
      },
    ],
    [
      {
        src: "../Aesthetics/mulmul/DSCF4509.webp",
        alt: "Mul Mul Image DSCF4509",
      },
    ],
    [
      {
        src: "../Aesthetics/mulmul/DSCF4446.webp",
        alt: "Mul Mul Image DSCF4446",
      },
    ],
  ];

  return (
    <>
      <HeroSection
        media={{
          type: "image",
          src: "/images/Aesthetics/honest.webp",
        }}
      />

      <Gap />

      <div class="container">
        <LazyLoad preload offset={1000} once>
          <GridMediaLayout
            mediaItems={mediaItems}
            rows={2}
            columns={2}
            useDynamicPadding={true}
            maxPadding={500}
            disablePaddingOnMobile={true}
          />
        </LazyLoad>

        <Gap size={0} />

        <div>
          <LazyLoad preload offset={1000} once>
            <img
              src="../logos-and-png-text/Amit_Aggarwal_Logo_BLACK_Bold1.png copy.png"
              alt="Unique Overlay Logo"
              className="unique-logo-image"
            />
          </LazyLoad>
        </div>

        {/* <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../logos-and-png-text/Amit_Aggarwal_Logo_BLACK_Bold1.png copy.png",
              type: "image",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={800}
            disablePaddingOnMobile={false}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={mehakCarouselImages}
            timer={4000}
            imageHeight={700}
            gap={5}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Aesthetics/Anurag-basement/DSCF6301.webp",
              type: "image",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={crossfadeGridMediaImages}
            columns={2}
            interval={4000}
            useDynamicPadding={true}
            maxPadding={500}
            disablePaddingOnMobile={true}
            gap={0}
          />
        </LazyLoad>

        {/* <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={ruya_carousel_images}
            timer={4000}
            imageHeight={700}
            gap={5}
          />
        </LazyLoad> */}

        <Gap size={10} />

        <div>
          <LazyLoad preload offset={1000} once>
            <img
              src="../logos-and-png-text/294951489_418577493622513_7289742779076437068_n-2 (1).png"
              alt="Unique Overlay Logo"
              className="unique-logo-image"
            />
          </LazyLoad>
        </div>

        {/* <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../logos-and-png-text/294951489_418577493622513_7289742779076437068_n-2 (1).png",
              type: "image",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={850}
            disablePaddingOnMobile={false}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap size={10} />

        <LazyLoad preload offset={1000} once>
          {/* <ImageCarousel images={rumani_carousel_images} timer={4000} /> */}
          <ResponsiveImageCarousel
            images={rumani_carousel_images}
            timer={4000}
            imageHeight={700}
            gap={5}
          />
        </LazyLoad>

        <Gap />

        <div className="aesthetics-with-logo">
          <LazyLoad preload offset={1000} once>
            <FullWidthMedia
              media={{
                src: "../Aesthetics/boult/DSCF3515.webp",
                type: "image",
              }}
              userInteracted={hasUserInteracted}
            />
          </LazyLoad>

          <div className="unique-logo-overlay-aesthetics">
            <LazyLoad preload offset={1000} once>
              <img
                src="../logos-and-png-text/boult2.png"
                alt="Unique Aesthetics Logo Overlay"
                className="unique-logo-image-aesthetics"
              />
            </LazyLoad>
          </div>
        </div>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../Aesthetics/grazia-maruhourmi/grazia-maruhourmi.webp",
              type: "image",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={700}
            disablePaddingOnMobile={true}
            // size="smallImg"
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={jerseyImages}
            columns={3}
            interval={0}
            useDynamicPadding={true}
            maxPadding={0}
            disablePaddingOnMobile={true}
            gap={0}
          />
        </LazyLoad>

        {/* <Gap /> */}

        {/* <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={crossfadeGridMediaImages2}
            columns={1}
            interval={4000}
            paddingLeft={300}
            paddingRight={300}
          />
        </LazyLoad> */}

        {/* <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthCarousel
            images={spitiCarouselImages}
            interval={4000}
            paddingLeft={0}
            paddingRight={0}
            animation="slideleft"
          />
        </LazyLoad> */}

        {/* <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={boultImages2Col}
            columns={2}
            interval={0}
            paddingLeft={500}
            paddingRight={500}
            gap={0}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <div class="padding-100">
            <ThreeColumns
              layout="three-equal"
              mediaList={[
                {
                  type: "image",
                  src: "../Aesthetics/boult/DSCF3495.webp",
                  column: "left",
                },
                {
                  type: "image",
                  src: "../logos-and-png-text/boult.png",
                  column: "center",
                  width: "30%",
                  height: "auto",
                  verticalAlign: "center",
                },
                {
                  type: "image",
                  src: "../Aesthetics/boult/DSCF3563.webp",
                  position: "right",
                },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ResponsiveImageCarousel
            images={kashmir_textiles_images}
            timer={3000}
            imageHeight={600}
            gap={5}
          />
        </LazyLoad>

        {/* <Gap size={0} /> */}

        {/* <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../logos-and-png-text/boult.webp",
              type: "image",
            }}
            column="center"
            paddingLeft={800}
            paddingRight={800}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        {/* <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={boultImages1Col}
            columns={1}
            interval={0}
            paddingLeft={500}
            paddingRight={500}
          />
        </LazyLoad> */}

        <Gap />

        {/* <div className="crossfade-container"> */}
        {/* Crossfade Image Columns */}
        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={kenwoodImages3Col}
            columns={3}
            interval={0}
            useDynamicPadding={true}
            maxPadding={0}
            disablePaddingOnMobile={true}
            gap={0}
          />
        </LazyLoad>

        {/* Logo Overlay */}
        <div>
          <LazyLoad preload offset={1000} once>
            <img
              src="../logos-and-png-text/english-heritage-have-updated-their-logo-for-the-first-time-v0-rfp5yp8ba2bd1.png"
              alt="Overlay Logo"
              className="englishHeritage"
            />
          </LazyLoad>
        </div>
        {/* </div> */}

        <Gap size={70} />

        {/* <LazyLoad preload offset={1000} once> */}
        {/* <GridMediaLayout
          mediaItems={vogueVidhishaImages}
          rows={2}
          columns={3}
          paddingLeft={0}
          paddingRight={0}
        /> */}
        {/* </LazyLoad> */}
        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={vogueVidhishaImagesRow1}
            columns={3}
            interval={0}
            useDynamicPadding={true}
            maxPadding={0}
            disablePaddingOnMobile={true}
            gap={0}
          />
        </LazyLoad>
        {/* <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={vogueVidhishaImagesRow2}
            columns={3}
            interval={0}
            paddingLeft={0}
            paddingRight={0}
            gap={0}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CrossfadeImageColumns
            images={mulmulImages2}
            columns={3}
            interval={0}
            useDynamicPadding={true}
            maxPadding={0}
            disablePaddingOnMobile={true}
            gap={0}
          />
        </LazyLoad>

        {/* <LazyLoad preload offset={1000} once> */}
        {/* <GridMediaLayout
          mediaItems={mulmulImages}
          rows={1}
          columns={3}
          paddingLeft={0}
          paddingRight={0}
        /> */}
        {/* </LazyLoad> */}
      </div>
      <Footer />
    </>
  );
}

export default Aesthetics;
